import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './core/user/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    constructor(
        private userService: UserService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        if (window.location.pathname === '/faq-search') {
            return;
        }
        if (window.location.href?.includes('isComingFromMail')) {
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        const ppToken = localStorage.getItem('pp-token');
        const randomId = localStorage.getItem('randomId');
        const userDetails = localStorage.getItem('user');
        const refreshToken = localStorage.getItem('pp-refresh-token');
        const isStudioX = urlParams.get('studioX') === 'true';
        this.userService.get().subscribe(
            (res) => {
                if (Object.keys(res).length === 0) {
                    if (!!isStudioX) {
                        this.router.navigateByUrl('sign-in?studioX=true');
                    } else {
                        this.router.navigateByUrl('sign-in');
                    }
                }
                if (!!ppToken && !!isStudioX) {
                    setTimeout((): void => {
                        window.localStorage.clear();
                        window.close();
                    }, 10000);
                    const url = `studiox:?accessToken=${ppToken}&randomId=${randomId}&user=${userDetails}&refreshToken=${refreshToken}`;
                    window.location.href = url;
                }
                const endPath = window.location.href.split('/').pop();

                if (endPath.length === 0) {
                    if (
                        res?.roles.find((role) => role?.name === 'Super Admin')
                    ) {
                        this.router.navigateByUrl('clients');
                    } else {
                        this.router.navigateByUrl('dashboard');
                    }
                }
            },
            (error) => {
                console.error(error);
            },
        );
    }
}
